module.exports = __webpack_public_path__ + "img/prev_sicur.888c20ed.png";